import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { GreenplumCopySource } from 'app/model/pipeline/copysource/greenplum.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GreenplumCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class GreenplumCopySourceAdapter extends CopySourceAdapter<GreenplumCopySource, Model.GreenplumSource> {
    protected override async _toResource(copySource: GreenplumCopySource): Promise<Model.GreenplumSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(GreenplumCopySource).name);
    }

    protected override async _toModel(
        resource: Model.GreenplumSource,
        copyActivity: CopyActivity
    ): Promise<GreenplumCopySource> {
        return this._toTabularModel(resource, copyActivity, GreenplumCopySource.MODEL);
    }
}
